__turbopack_context__.v({
  "tooltip": "cfZ4zG_tooltip",
});
